import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import SettingsApplications from '@material-ui/icons/SettingsApplications';

import Dialog from '~/components/Dialog';
import Button from '~/components/Button';
import Can from '~/contexts/Can';

import PackagesDialogContent from './components/PackageList';

const ManagePackages = ({ owner, user, isOpen, handleClose, onUpdateAddons }) => {
  const [isAddPackage, setIsAddPackage] = useState(false);
  const { t } = useTranslation();

  return (
    <Dialog
      icon={<SettingsApplications />}
      isOpen={isOpen}
      handleClose={handleClose}
      title={`${t('person.extras.packsOfUser')} ${user.name}`}
      dialogActions={
        <React.Fragment>
          <Can I="new_package" a="Peoples">
            <Button onClick={() => setIsAddPackage(true)} color="primary">
              {t('action.new')}
            </Button>
          </Can>
        </React.Fragment>
      }
    >
      <PackagesDialogContent
        user={user}
        owner={owner}
        onUpdateAddons={onUpdateAddons}
        isAddPackage={isAddPackage}
        setIsAddPackage={setIsAddPackage}
      />
    </Dialog>
  );
};

ManagePackages.propTypes = {
  owner: PropTypes.object.isRequired,
  user: PropTypes.object.isRequired,
  isOpen: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
  onUpdateAddons: PropTypes.func,
};

export default React.memo(ManagePackages);
